module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Copyright-rw exclude-print-rw page-open-auto-rw",
    attrs: {
      "epub:type": "frontmatter copyright-page",
      "id": "Copyright1"
    }
  }, [_c('div', {
    staticClass: "block-rw copyright-rw",
    attrs: {
      "id": "copyright1"
    }
  }, [_c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p26"
    }
  }, [_c('span', [_vm._v("This book is a work of fiction. Names, characters, places, and incidents are the product of the author’s imagination or are used fictitiously. Any resemblance to actual events, locales, or persons, living or dead, is coincidental.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p27"
    }
  }, [_c('span', [_vm._v("Copyright © 2017 by Jennifer Snow"), _c('br'), _vm._v("\nExcerpt from "), _c('i', [_vm._v("Maybe This Time")]), _vm._v(" copyright © 2016 by Jennifer Snow"), _c('br'), _vm._v("\nCover design by Elizabeth Turner. Cover photography by Claudio Marinesco. Cover images © Shutterstock. Cover copyright © 2017 by Hachette Book Group, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p28"
    }
  }, [_c('span', [_vm._v("Hachette Book Group supports the right to free expression and the value of copyright. The purpose of copyright is to encourage writers and artists to produce the creative works that enrich our culture.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p29"
    }
  }, [_c('span', [_vm._v("The scanning, uploading, and distribution of this book without permission is a theft of the author’s intellectual property. If you would like permission to use material from the book (other than for review purposes), please contact permissions@hbgusa.com. Thank you for your support of the author’s rights.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p30"
    }
  }, [_c('span', [_vm._v("Forever"), _c('br'), _vm._v("\nHachette Book Group"), _c('br'), _vm._v("\n1290 Avenue of the Americas"), _c('br'), _vm._v("\nNew York, NY 10104"), _c('br'), _c('a', {
    attrs: {
      "href": "http://forever-romance.com",
      "target": "_blank"
    }
  }, [_vm._v("forever-romance.com")]), _c('br'), _c('a', {
    attrs: {
      "href": "http://twitter.com/foreverromance",
      "target": "_blank"
    }
  }, [_vm._v("twitter.com/foreverromance")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p31"
    }
  }, [_c('span', [_vm._v("First Edition: September 2017")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p32"
    }
  }, [_c('span', [_vm._v("Forever is an imprint of Grand Central Publishing. The Forever name and logo are trademarks of Hachette Book Group, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p33"
    }
  }, [_c('span', [_vm._v("The publisher is not responsible for websites (or their content) that are not owned by the publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p34"
    }
  }, [_c('span', [_vm._v("The Hachette Speakers Bureau provides a wide range of authors for speaking events. To find out more, go to www.hachettespeakersbureau.com or call (866) 376-6591.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p35"
    }
  }, [_c('span', [_vm._v("ISBNs: 978-1-4555-9492-4 (mass market), 978-1-4555-9490-0 (ebook)")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p36"
    }
  }, [_c('span', [_vm._v("E3-20190922-PDJ-PC-DPU")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-742da9c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s003-Copyright-01.vue
// module id = 66
// module chunks = 0